import styled from "styled-components"

export const StyledBlackWhiteLayoutWrapper = styled.div`
  background: #ffffff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  color: #252525;

  ${({ showLinks }) => showLinks && `
    overflow-y: hidden !important;  
`}
`

export const StyledBlackWhiteContainer = styled.div`
  flex: 1 1 auto;
  position: relative;
  z-index: 3;
`